import { useState } from "react";

export const useCheckFormMultiple = (
    initValue = {
        tes: false,
    }
) => {
    const [checkValues, setCheckValues] = useState(initValue);

    const onChangueValue = (key, value) => {

        setCheckValues({
            ...checkValues,
            [key]: value,
        });
    };

    const updateInitValue = (value) => {
        setCheckValues(value);
    };

    return {
        checkValues,
        onChangueValue,
        updateInitValue,
    };
};
